// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sliggoo_hisui: PokeData = {
  "id": 10241,
  "name": "sliggoo-hisui",
  "height": 7,
  "weight": 685,
  "base_experience": 158,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "hydro-pump",
    "absorb",
    "bubble",
    "acid-armor",
    "curse",
    "flail",
    "protect",
    "dragon-breath",
    "rain-dance",
    "muddy-water",
    "water-pulse",
    "dragon-pulse",
    "iron-head",
    "acid-spray",
    "shelter"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "bubble",
    "curse",
    "protect",
    "dragon-breath",
    "rain-dance",
    "dragon-pulse",
    "inner-spirit",
    "dragon-fang",
    "iron-defense",
    "metal-claw",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 362,
    "item": null,
    "species": [
      {
        "name": "goomy",
        "order": 704,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sliggoo",
        "order": 705,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 704,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "goodra",
        "order": 706,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 705,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 155,
    "speed": 80,
    "ability_power": 165
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
